//
// This file contains the event handler helper functions
// for all of the donate form functionality
//

// store all paymethod content in variables only display active one
let tabContents = {};
const panesContainerDiv = document.getElementById('paymethod-panes');
export function clearTabContents(contentID) {
  for (let pane of document.querySelectorAll('.method')) {  
    if (pane.id !== contentID) {
      pane.classList.remove('active');
      tabContents[pane.id] = panesContainerDiv.removeChild(pane);
    }
  }
  if (typeof tabContents[contentID] !== 'undefined') {
    tabContents[contentID].classList.add('active');
    panesContainerDiv.appendChild(tabContents[contentID]);
  }
}



// checks monthly vs one-time radio buttons and on change 
// updates which payment tab options are active
export function updatePayOptionTabs() {
  let frequencyRadioChecked = document.querySelector('input[name="recurrence"]:checked');
  const interrupterDiv = document.querySelector('div.interrupter');
  let payTabsNoMonthly = document.querySelectorAll('#paymethod-nav li.no-monthly');
  let payTabsNoOneTime = document.querySelectorAll('#paymethod-nav li.no-onetime');

  // if no value in the radio buttons bail
  if (frequencyRadioChecked === null) { return; }

  if (frequencyRadioChecked.value === "Monthly") {
    if (interrupterDiv) {
      interrupterDiv.hidden = true;
    }
    for (let payTab of payTabsNoMonthly) {
      payTab.classList.add('disabled');
    }
    for (let payTab of payTabsNoOneTime) {
      payTab.classList.remove('disabled');
    }
  } else if (frequencyRadioChecked.value === "One Time") {
    if (interrupterDiv) {
      interrupterDiv.hidden = false;
    }
    for (let payTab of payTabsNoMonthly) {
      payTab.classList.remove('disabled');
    }
    for (let payTab of payTabsNoOneTime) {
      payTab.classList.add('disabled');
    }
  } 
  checkAndToggleUseOnDay();
  return;
}


// checks if monthly radio is selected and hides or shows the 
// selection day dropdown
export function checkAndToggleUseOnDay() {
  const useOnDay = document.getElementById("div_formtools_use_on_day");
  let paymentMethodTab = document.querySelector("#paymethod-nav li.active");

  // if either of these is true show day of month selector
  let frequency = document.querySelector('input[name="recurrence"]:checked');
  if (frequency === null) {
    frequency = document.querySelector('input[name="recurrence"][type="hidden"]');
    if (frequency === null) {
      frequency = "";
    }
  }

  // is "monthly" radio checked?
  if (
    frequency.value === "Monthly" && 
    (paymentMethodTab === null || paymentMethodTab.classList.contains("use-on-day-enabled"))
  ) {
    useOnDay.classList.add("d-flex");
    useOnDay.classList.add("basic-labels");
  } else {
    useOnDay.classList.remove("d-flex");
  }
  return;  
}

